import { ref, onMounted, onBeforeUnmount } from 'vue'

const isHeaderHidden = ref(false)
const lastScrollY = ref(0)
const scrollThreshold = 5
const hideThreshold = 50

let scrollListenerAttached = false
let componentCount = 0

const handleScroll = (): void => {
  const currentScrollY = window.scrollY || window.pageYOffset

  if (lastScrollY.value === 0) {
    lastScrollY.value = currentScrollY
  }

  if (Math.abs(currentScrollY - lastScrollY.value) < scrollThreshold) {
    return
  }

  const scrollDelta = currentScrollY - lastScrollY.value

  if (scrollDelta > 0 && currentScrollY > hideThreshold) {
    isHeaderHidden.value = true
  } else if (scrollDelta < 0) {
    isHeaderHidden.value = false
  }

  if (currentScrollY <= hideThreshold) {
    isHeaderHidden.value = false
  }

  lastScrollY.value = currentScrollY
}

export function useHeaderScroll() {
  onMounted(() => {
    componentCount++
    if (!scrollListenerAttached && typeof window !== 'undefined') {
      lastScrollY.value = window.scrollY || window.pageYOffset
      isHeaderHidden.value = false

      window.addEventListener('scroll', handleScroll, { passive: true })
      scrollListenerAttached = true
    }
  })

  onBeforeUnmount(() => {
    componentCount--
    if (componentCount === 0 && scrollListenerAttached && typeof window !== 'undefined') {
      window.removeEventListener('scroll', handleScroll)
      scrollListenerAttached = false
    }
  })

  return {
    isHeaderHidden,
  }
}
